import React from 'react';

interface IProps {
  style?: any;
}

const SaveTemplateIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.021 7.201h-4.94c-.19 0-.38.18-.38.36v10.08c0 .18.19.36.38.36h4.94c.19 0 .38-.18.38-.36V7.561c0-.18-.19-.36-.38-.36zM6.081 5.4h12.54c.19 0 .38-.18.38-.36V.9c0-.54-.38-.9-.95-.9H6.081c-.19 0-.38.18-.38.36v4.68c0 .18.19.36.38.36zM13.299 7.561v10.08c0 .18.19.36.38.36h4.37c.57 0 .95-.36.95-.9v-9.54c0-.18-.19-.36-.38-.36h-4.94c-.19 0-.38.18-.38.36zM3.42 0H.95C.38 0 0 .36 0 .9v16.2c0 .54.38.9.95.9h2.47c.19 0 .38-.18.38-.36V.36C3.8.18 3.61 0 3.42 0z" fill={props.style?.fillColor ? props.style.fillColor : "#204078"}/>
    </svg>
  )
}

export default SaveTemplateIcon;